<template>
    <div style="background-color: #f3f7fe;">
    <el-row style="margin-top: 20px">
    <el-col :span="4"><div class="grid-content "></div></el-col>
    <el-col :span="16">
        <el-table
                :show-header="false"
                :data="tableData"
                stripe
                border
                v-loading="loading"
                element-loading-text="拼命加载中"

                style="width: 100%">
            <el-table-column  prop="name"  min-width="25%" align="center" >
            </el-table-column>
            <el-table-column  prop="value"  min-width="75%" align="center" >
                <template slot-scope="scope">
                    <span v-if="scope.row.value !== '预览'">{{scope.row.value}}</span>
                    <span v-else-if="scope.row.value === '预览'">
                        <el-button type="text" @click="showDialog([scope.row])">查看说明书</el-button>
                    </span>
                </template>


            </el-table-column>
        </el-table>
    </el-col>
    <el-col :span="4"><div class="grid-content "></div></el-col>
    </el-row>

    <el-row style="margin: 20px 0px;text-align: center">
        <el-col :span="4"><div class="grid-content "></div></el-col>
        <el-col :span="16">
            免责声明：因技术原因，无法保障本页面产品联动价等信息的及时性更新和准确性，请查询人自行负责，信息仅供参考
        </el-col>
        <el-col :span="4"><div class="grid-content "></div></el-col>
    </el-row>

    <!--查看说明书-->
    <el-dialog :title="title" :visible.sync="smsDialog" width="60%" :before-close="beforeClose">
        <iframe id="viewFile" @load="changeHeight()" height="100%" :src="visibleSrc" frameborder="0" scrolling="no" ></iframe>
    </el-dialog>
    </div>
</template>

<script>
    import {getDetail} from '../../api/drug'
    export default {
        data() {
            return {
                tableData: [{name:"通用名",value: ""},{name:"商用名",value: ""},{name:"剂型",value: ""},
                    {name:"规格",value: ""},{name:"转换比",value: ""},{name:"最小包装单位",value: ""},{name:"包材",value: ""},
                    {name:"市场参考价",value: ""},{name:"联动参考价",value: ""},{name:"红线价",value: ""},{name:"生产企业",value: ""},
                    {name:"质量层次",value: ""},{name:"国采中标",value: ""},{name:"省采中标",value: ""},
                    {name:"医保编号",value: ""},{name:"医保备注",value: ""},{name:"批准文号",value: ""},
                    {name:"本位码",value: ""},{name:"说明书",value: "",url:""},{name:"信息来源",value: "四川省药械集中采购及医药价格监管平台/国家药品监督管理局药品审评中心"},
                    ],
                loading: false, //是显示加载
                title:'查看说明书',
                smsDialog: false,
                visibleSrc:''

            }
        },
        created() {
            let drugId =this.$route.query.id;
            // if (localStorage.getItem('drugId')){
            //     drugId = localStorage.getItem("drugId");
            //     localStorage.clear();
            // };
            if (drugId) {
                this.loading = true;
                getDetail({id: drugId}).then(res => {
                    this.loading = false
                    if (res.resultCode.code !== '00000') {
                        this.$message({
                            type: 'info',
                            message: res.resultCode.cnMsg
                        })
                    } else {
                        console.log(this.tableData.length)
                        this.tableData[0].value = res.result.genericName;
                        this.tableData[1].value = res.result.tradeName;
                        this.tableData[2].value = res.result.dosage;
                        this.tableData[3].value = res.result.specification;
                        this.tableData[4].value = res.result.conversionRatio;
                        this.tableData[5].value = res.result.smallestUnit;
                        this.tableData[6].value = res.result.packingMaterials;
                        this.tableData[7].value = res.result.retailPrice;
                        this.tableData[8].value = res.result.linkagePrice;
                        this.tableData[9].value = res.result.redPrice;
                        this.tableData[10].value = res.result.productionEnterprise;
                        this.tableData[11].value = res.result.qualityLevel;
                        this.tableData[12].value = res.result.countriesWining;
                        this.tableData[13].value = res.result.provinceWining;
                        this.tableData[14].value = res.result.healthcareCode;
                        this.tableData[15].value = res.result.healthcareNote;
                        this.tableData[16].value = res.result.approvalNumber;
                        this.tableData[17].value = res.result.baseCode;
                        // console.log(res.result.smsUrl)
                        if (res.result.smsUrl) {
                            console.log(res.result.smsUrl+"   ,"+res.result.genericName )
                            this.tableData[18].value="预览";
                            this.tableData[18].url=res.result.smsUrl;
                        }



                    }

                })
            }

        },
        methods:{
            showDialog(rows){
                let url = "http://www.ycbyg.cn/image/link/sms/"+this.tableData[18].url;

                // saveable = true 开始下载按钮
                window.open("https://view.xdocin.com/view?src=" + encodeURIComponent(url));
                    // +"&saveable=true");

            },
            beforeClose() {
                this.smsDialog = false
                this.visibleSrc=""
            },
            changeHeight() {
                //获得iframe标签
                let fileIframe = document.getElementById("viewFile");
                //得到iframe实际body内容
                let fileIframeBody = fileIframe.contentWindow.document.body
                //设计iframe的body展示样式
                let fileIframeStyle = 'height:100%;display: flex; justify-content: center; align-items: center;'
                fileIframeBody.style = fileIframeStyle

                let fileIframeNodeName = ''

                //得到实际展示的标签
                if(fileIframeBody.childNodes[0] ){
                    fileIframeNodeName = fileIframeBody.childNodes[0].nodeName.toLowerCase()
                    if(fileIframeNodeName === 'img'){
                        //得到展示图片的实际高度，赋值给iframe，不再展示他的滚动条
                        fileIframe.height = fileIframeBody.childNodes[0].naturalHeight
                        fileIframe.width = fileIframeBody.childNodes[0].naturalWidth
                        fileIframeBody.style = fileIframeStyle

                        //如果展示文件为pdf,实际展示标签为embed
                    }else if(fileIframeNodeName === 'embed') {
                        //目前我还只会设死标签
                        fileIframe.height = 500
                        fileIframe.width = 300
                    }
                }else {
                    fileIframe.height = 150
                    fileIframe.width = 300
                }
            },
        }
    }
</script>





<style >
    /*#app{*/
    /*    background-color: #f3f7fe*/
    /*}*/
    .el-main{
        background-color: #f3f7fe
    }
    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }
</style>


// WEBPACK FOOTER //
// src/views/drug/DrugInfo.vue